export function isStandaloneMode() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    window.matchMedia('(display-mode: minimal-ui)').matches
  );
}

/**
 * Detect device class for PWA install UX.
 * @returns {'ios' | 'android' | 'desktop' | 'unknown'}
 */
export function detectPwaPlatform() {
  if (typeof window === 'undefined') return 'unknown';
  const ua = window.navigator.userAgent.toLowerCase();
  // iPadOS 13+ can report as Mac — check touch points
  const isIpadOs =
    /macintosh/.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1;
  if (/iphone|ipad|ipod/.test(ua) || isIpadOs) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'desktop';
}

/** True when user is in Instagram / Facebook / LinkedIn / etc. in-app browser on iOS */
export function isIOSInAppBrowser() {
  if (typeof window === 'undefined') return false;
  if (detectPwaPlatform() !== 'ios') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  return (
    /fbav|fban|fb_iab|instagram|line\/|linkedin|twitter|tiktok|snapchat|wv/.test(ua) ||
    // Chrome/Firefox/Edge on iOS still use WebKit, but Share → Add to Home Screen is Safari-only
    (/crios|fxios|edgios/.test(ua) && !/safari/.test(ua))
  );
}

/** Safari on iOS (best path for Add to Home Screen) */
export function isIOSSafari() {
  if (typeof window === 'undefined') return false;
  if (detectPwaPlatform() !== 'ios') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  // Chrome / Firefox / Edge on iOS include the word "Safari" in UA — exclude them
  if (/crios|fxios|edgios|opr\//.test(ua)) return false;
  if (isIOSInAppBrowser()) return false;
  return /safari/.test(ua);
}

/**
 * How this browser can install the PWA.
 * - native: Chrome/Edge/Android beforeinstallprompt available (checked separately)
 * - ios-safari: Share → Add to Home Screen
 * - ios-other: must open in Safari first
 * - android-manual: Chrome menu → Install app / Add to Home screen
 * - desktop-manual: browser install icon / menu
 */
export function getManualInstallKind() {
  const platform = detectPwaPlatform();
  if (platform === 'ios') {
    return isIOSSafari() ? 'ios-safari' : 'ios-other';
  }
  if (platform === 'android') return 'android-manual';
  return 'desktop-manual';
}
